//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import React from 'react';
import { Box } from '@mui/material';
import Header from '@/components/Header/Header';
import Footer from './Footer';

interface LayoutProps {
  children?: React.ReactNode;
  selectedMenuItem?: string;
  menuClickCallback?: () => void;
  hiddenBars?: boolean;
}

const Layout = ({ children, selectedMenuItem = '', menuClickCallback,
                  hiddenBars }: LayoutProps) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        color: 'text.primary',
      }}
    >
      <Header
        selectedMenuItem={selectedMenuItem}
        menuClickCallback={menuClickCallback}
        hidden={hiddenBars}
      />

      {/* Focusable so the "Skip to main content" link moves focus and not
          just the scroll position, and so a panel dismissal with no launcher
          left to return to has a landmark to land on. */}
      <Box
        component="main"
        id="main-content"
        tabIndex={-1}
        sx={{ flexGrow: 1, pb: 2, outline: 'none' }}
      >
        {children}
      </Box>

      <Footer hidden={hiddenBars} />
    </Box>
  );
};

export default Layout;
